import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type {
  TypePatchOwnerSupplierManagerModifyParams,
  TypePatchOwnerSupplierManagerModifyResponse,
} from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 공급사 관리] 담당자 정보 수정
 */
const usePatchOwnerSupplierManagerModify = () => {
  const endPoint = '/api-owner/owner-supplier-manager/modify';

  const patchOwnerSupplierManagerModify = async (params: TypePatchOwnerSupplierManagerModifyParams) => {
    return axiosInstance
      .patch<TypePatchOwnerSupplierManagerModifyResponse>(endPoint, params)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { patchOwnerSupplierManagerModify };
};

export default usePatchOwnerSupplierManagerModify;
